export default __webpack_public_path__ + "463051b573c0fa441940a35245221b84.svg";